module.exports = __webpack_public_path__ + "static/media/60fpsparrot.0c554f63.gif";